"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * HTML data attributes used by the framework.
 */
var DataAttributes;
(function (DataAttributes) {
    DataAttributes["INPUT_DISABLED"] = "data-wf-disabled";
})(DataAttributes = exports.DataAttributes || (exports.DataAttributes = {}));
